import Vue from 'vue'
import VueRouter from 'vue-router'

import Index from '../views/index.vue'
import About from '../views/about.vue'
import Treatments from '../views/treatments.vue'
import Blog from '../views/blog.vue'
import BlogDetail from '../views/blogDetail.vue'
import News from '../views/news.vue'
import NewDetail from '../views/newDetail.vue'
import Pricing from '../views/pricing.vue'
import Faq from '../views/faq.vue'
import Contact from '../views/contact.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'home', component: Index },
  { path: '/about', name: 'about', component: About },
  { path: '/treatments', name: 'treatments', component: Treatments },
  { path: '/treatments/detail/:id', name: 'treatmentDetail', component: Treatments },
  { path: '/blog', name: 'blog', component: Blog },
  { path: '/blog/detail/:id', name: 'blogDetail', component: BlogDetail },
  { path: '/news', name: 'news', component: News },
  { path: '/news/detail/:id', name: 'newsDetail', component: NewDetail },
  { path: '/pricing', name: 'pricing', component: Pricing },
  { path: '/faq', name: 'faq', component: Faq },
  { path: '/contact', name: 'contact', component: Contact },
  { path: '*', redirect: '/' },
]

const router = new VueRouter({
  // 用 hash 模式避免服务器额外配置
  mode: 'hash',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

export default router

